<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-guide-dialog-panel tenga la fascia panna a filo del bordo inferiore. -->
<h2 mat-dialog-title>Gestione collaboratori:</h2>

<mat-dialog-content>
  <p class="mt-3">Da questa sezione puoi dare accesso alla tua organizzazione ad altre persone, ad esempio il tuo commercialista o un collaboratore. Ecco come funziona.</p>
  <p><strong>1. Crea l'invito:</strong> premi "Nuovo invito", inserisci l'email della persona che vuoi invitare e premi "Crea invito". L'invito comparirà nella lista "Inviti organizzazione".</p>
  <p><strong>2. Condividi il link:</strong> premi l'icona del link <mat-icon class="inline-icon">link</mat-icon> sulla card dell'invito e copia il collegamento. Invialo tu alla persona invitata, ad esempio via email o messaggio.</p>
  <p><strong>3. Accettazione:</strong> la persona apre il link e accede con la <u>stessa email</u> a cui è intestato l'invito. Se è collegata con un'altra email dovrà cambiare utente. A quel punto può accettare o rifiutare l'invito.</p>
  <p><strong>Stati dell'invito:</strong></p>
  <ul>
    <li class="ms-4"><strong>In attesa:</strong> l'invito è stato creato ma la persona non ha ancora risposto.</li>
    <li class="ms-4"><strong>Accettato:</strong> la persona ora ha accesso alla tua organizzazione.</li>
    <li class="ms-4"><strong>Rifiutato:</strong> la persona ha declinato l'invito. Se serve, puoi crearne uno nuovo.</li>
    <li class="ms-4"><strong>Scaduto:</strong> l'invito non è più valido. Creane uno nuovo per riprovare.</li>
  </ul>
  <p>Usa il tasto "Aggiorna" per vedere lo stato più recente degli inviti.</p>
  <p class="pb-3"><u>Nota bene:</u> chi accetta l'invito accede ai dati della tua organizzazione e può anche emettere fatture! Invita solo persone di cui ti fidi.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <!-- Sulla fascia panna: il petrol pieno bordato nero, l'unica azione del
       dialog. -->
  <button
    matButton="filled"
    mat-dialog-close
    class="izy-button-primary custom-button-border">
    <mat-icon>check</mat-icon>
    Ok, capito
  </button>
</mat-dialog-actions>
